export const reportOptions = [
  { value: 1, label: "Horário errado" },
  { value: 2, label: "Itinerário (pontos de paradas) errado" },
  { value: 3, label: "Ponto de recarga errado" },
  { value: 4, label: "Erro no carregamento do site" },
  { value: 5, label: "Travamento" },
  { value: 6, label: "Dados da companhia errados" },
  { value: 7, label: "Outros" }
];
